import { Label, MultiSelect } from "@tellescope/ui";
import { TemplateFormDialogContentsSectionForm } from "../types";
import { Target } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface CarePlanTasksSectionProps {
  form: TemplateFormDialogContentsSectionForm<"carePlanTasks">;
}

export const CarePlanTasksSection = ({ form }: CarePlanTasksSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <div className="space-y-4">
      <Label>
        <Target size={16} />
        {t("Tasks")}
      </Label>
      <MultiSelect
        {...form.getCustomFieldProps("carePlanTasks")}
        options={form.values.carePlanTasks.map((value) => ({ label: value, value }))}
        creator={{
          render: (inputValue) => <p>{t("Add '{{task}}' task", { task: inputValue })}</p>,
          transform: (inputValue) => inputValue,
          onCreate: (val) =>
            form.setFieldValue("carePlanTasks", Array.from(new Set([...(form.values.carePlanTasks ?? []), val.value]))),
        }}
        placeholder={t("Add a task...")}
        className="font-light w-full"
      />
    </div>
  );
};
